import React from "react";
import Link from "gatsby-link";
import Container from "./container";
import SectionHeading from "./section-heading";


const ServiceItem = ({ name, desc, icon}) => (
  <div className="service-item">
    <div className="service-icon">
      <img src={`/static/${icon}.png`} />
    </div>
    <div className="service-name">{name}</div>
    <div className="service-desc">{desc}</div>
  </div>
);

const HomepageServices = (props) => (
  <div className="homepage-services">
    <Container>

      <SectionHeading
        title="Building Transformational Companies"
        description="Through insight into a broader market perspective, we assist our partners in becoming giants within their fields of interest by reducing costs, focusing on growth, and creating a cohesive eco-system."
      />

      <div className="why-work-with-us">
        <div>
          <h3>Improve your business proces</h3>
          <p>Through insight into a broader market perspective, we assist our partners in becoming giants within their fields of interest by reducing costs, focusing on growth, and creating a cohesive eco-system. The consistent change in the global business environment has made it obligatory for a company to improve their business process. We are here to implement our knowledge where the business process improvement is the only outcome by helping you  to use your resources wisely and by producing products or services of high quality. </p>
        </div>

       <div>
          <h3>Why work with us?</h3>
          <p>All major companies often turn to consulting companies in order to improve their strategy and operations. Being objective while assessing your processes only helps with identifying and prioritizing opportunities for business growth. We analyze the market and we help you understand what sets you apart from the competition. By creating a strategy with us we guarantee you will only have positive outcome. To learn more about what we do and our projects feel free to contact us.</p>
        </div>
      </div>

      <div className="services-container">
        {props.services.map(service => <ServiceItem key={service.name} {...service} />)}
      </div>

      <div className="services-read-more">
        <Link to="/consulting">
          <div className="button-purple">
            Read More
          </div>
        </Link>
      </div>

    </Container>
  </div>
);

export default HomepageServices;



// WEBPACK FOOTER //
// ./src/components/homepage-services.js